import {CustomerInstanceVenueData} from "./customer-instance-venue.data";
import {BillingAccountSummaryData} from "./billing-account/billing-account-summary.data";
import {VenueContactData} from "./venue-contact/venue-contact.data";
import {VenuePlanData} from "./venue-plan/venue-plan.data";
import {ContractData} from "./contract/contract.data";
import {VenueAddress} from "./venue-address/venue-address.data";
import {VenueCompany} from "./venue-company/venue-company.data";
import {CustomerInstance} from "../controls/customer-instance-select-control/customer-instance-select-control.component";
import {VenueMenuData} from "./menu/venue-menu.data";
import {VenueServices} from "./venue-services/venue-services.data";
import {VenueCardVerification} from "./venue-card-verification/venue-card-verification.data";
import {SubscriptionData} from "./venue-plan/subscription.data";
import {AppPaymentAccountData} from "../app-payment-account/app-payment-account.data";
import {SalesHandoverData} from "./sales-handover/sales-handover.data";

export class VenueTask {
    id: string;

    formattedTime: string;

    clickUpId: string;

    pendingSalesHandover: boolean;
}

export class CustomerInstanceVenueViewData {
    instance: CustomerInstance;
    venue: CustomerInstanceVenueData;
    primaryContact: VenueContactData;
    siteContact: VenueContactData;
    billingAccount: BillingAccountSummaryData;
    venuePlan: VenuePlanData;
    contract: ContractData;
    address: VenueAddress;
    company: VenueCompany;
    buildTask: VenueTask;
    menus: VenueMenuData[];
    services: VenueServices;
    cardVerification: VenueCardVerification;
    subscription: SubscriptionData;
    appPaymentAccount: AppPaymentAccountData;
    salesHandover: SalesHandoverData;
    hasSales: boolean;
    groupId: string;
}
